'use strict';

angular.module('licensure.services')
    .factory('IntegrationLocation', ['$http', '$q', function ($http, $q) {
        return {
            getLess: function (enterpriseId) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/AdminModule/Enterprises/' + enterpriseId + '/IntegrationLocation/Less')
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });
                return d.promise;
            },

            queryArcGisFeatureLayer: function (args, timeout) {
                var d = $q.defer();

                if (args.searchTerm == null || args.searchTerm == undefined) {
                    d.resolve(null);
                    return d.promise;
                }

                $http
                    .get(apiLocation + '/api/AdminModule/Enterprises/IntegrationLocations/' + args.locationIntegrationId + '/QueryArcGisFeatureLayer', {
                        params: { search: args.searchTerm },
                        timeout: (timeout != null ? timeout.promise : null)
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });
                return d.promise;
            }
        }
    }]);